export default {
  props: {
    color: {
      Type: String,
      default: "white"
    },
    markerImg: {
      type: String,
      required: false
    },
    markerNumber: {
      required: false
    },
    placeName: {
      required:false
    },
    textColor: {
      required:false,
      default: "white"
    }
  },
  computed: {
    singleDigitText() {
      return this.markerNumber && this.markerNumber <= 9;
    },
    doubleDigitText() {
      return this.markerNumber && this.markerNumber > 9;
    },
    tripleDigitText() {
      return this.markerNumber && this.markerNumber > 99;
    },
    fourDigitText() {
      return this.markerNumber && this.markerNumber > 999;
    }
  }
};
